export default "__VITE_ASSET__96d60c85__"